import React, { createContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import isValidUrl from 'src/util/isValidUrl';

const initialUserData = {
  language: 'ja',
  available_apps: [],
  common_links: []
};

const UserContext = createContext({
  user: { ...initialUserData }
});

export const UserProvider = ({ children }) => {
  const { user } = useAuth0();
  const userData = user
    ? Object.keys(user).reduce((obj, key) => {
        if (isValidUrl(key)) {
          const url = new URL(key);
          obj[url.pathname.replace(/\//g, '')] = user[key];
        } else {
          obj[key] = user[key];
        }
        return obj;
      }, {})
    : { ...initialUserData };
  return (
    <UserContext.Provider value={{ user: { ...userData } }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
